import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 *
 * Search for form fill data.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = async listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.FORM_FILL_DATA,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const FormFillDataService = {
  FindMany
}

export default FormFillDataService
